<template>
  <div class="table_wrap">
    <div class="filter_wrap">
      <div class="filter_row mb40">
        <div class="filter_content">
          <div class="title-filter mb5">매칭일</div>
          <el-date-picker class="filter-date" value-format="yyyy-MM-dd" v-model="filterDate" type="daterange"
                          @change="setFilterFunc('cr', filterDate)" start-placeholder="시작일" end-placeholder="종료일"
                          placement="bottom-start" :editable="false"></el-date-picker>
                          
        </div>
      </div>
      <div class="filter_row">
        <div class="filter_content">
          <div class="filter mr10">
            <el-select v-model="searchInputOption" class="el-select">
              <el-option v-for="item in selectOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="filter">
            <el-input placeholder="검색어를 입력해주세요." class="littleShort mr10"
                      @keypress.enter.native="setFilterFunc(searchInputOption, searchInput)" v-model="searchInput"></el-input>
            <el-button class="com_search" @click="setFilterFunc(searchInputOption, searchInput)">검색</el-button>
          </div>
        </div>
      </div>
    </div>

    <div class="filter-show-count mt15 mb15">
      <el-select v-model="size" @change="changePage('size', size)" class="select-common">
        <el-option v-for="sizeData in sizeList" :key="`size${sizeData}`" :value="sizeData"
                   :label="`${sizeData}개씩 보기`"></el-option>
      </el-select>
    </div>
  </div>

</template>

<script>
import utilityUtil from "@/components/utility/utilityUtil";
import alertMixins from "@/mixins/alertMixins";
import util from "@/mixins/util";
import {utilityUseStatus, utilitySellStatus} from "@/service/utilityService";

const {filterConfig} = utilityUtil;
export default {
  name: "UtilityFilterManagerLayout",
  mixins: [utilityUtil, alertMixins],
  components: {},
  inject: ["setPage", "setFilter"],
  provide() {
    return {};
  },
  props: {
    filterData: {
      default: () => {
      },
    },
    paginationData: {
      default: () => {
        return {total: 0, page: 0, size: 0};
      },
    },

    utilTopCategory: {
      default: () => {
        return [];
      },
    },
    utilBottomCategory: {
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      utilityUseStatus: utilityUseStatus,
      utilitySellStatus: utilitySellStatus,
      filterDate: "",
      searchInput: "",
      selectOptions: [
        {
          label: '아이디',
          value: 'mid',
        },
        {
          label: '닉네임',
          value: 'ni',
        },
        {
          label: '이름',
          value: 'na',
        },
      ],
      topCategory: '',
      category: '',
      sellSelect: '',
      useSelect: '',
      filterSelect: "",
      selectOption: "",
      searchInputOption: "mid",

      size: 10,
      sizeList: [10, 50, 100],

      bottomCateList: [],
    };
  },
  beforeRouterEnter() {
  },
  created() {
  },
  mounted() {
  },
  beforeUnmount() {
  },
  unmounted() {
  },
  computed: {},
  methods: {
    setFilterFunc(key, value) {
      console.log("ket",key,value)
      this.setFilter(key, value);
    },
    setterFilterDataInData() {
      let classnames = Object.keys(this.filterData);
      classnames.forEach((classname) => {
        let obj = this.filterData[classname];
        let type = filterConfig[obj.key].type;
        if (this.hasOwnProperty(classname)) {
          if (type == "query") {
            this[classname] = obj.query;
            if (this.hasOwnProperty(classname + "Option")) {
              this[classname + "Option"] = obj.key;
            }
          } else if (type === "between") {
            this[classname] = [obj.start, obj.end];
          } else if (type === "terms") {
            this[classname] = obj.terms;
          } else if (type === "match") {
            if (isNaN(obj.value)) {
              this[classname] = obj.value;
            } else {
              this[classname] = Number(obj.value);
            }
          }
        }
      });
      this.size = this.paginationData.size;
    },
    changePage(key, value) {
      this.setPage(key, value);
    },
    setFilterArrayFunc(key, value) {
      let arr = []
      if (!util.isEmpty(value)) {
        arr.push(value)
      }
      this.setFilter(key, arr);
    },
  },
  watch: {},
};
</script>

<style scoped></style>
